import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SharedLogoHeaderService {
  private logoSource = new BehaviorSubject<string>("");
  logo$ = this.logoSource.asObservable();

  constructor() {}

  setLogo(newLogo: string) {
    this.logoSource.next(newLogo);
  }
}
